import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { LabeledSelect } from 'components/Blocks';
import { EarthIcon } from 'components/Icons';

import { COUNTRIES } from 'utils/countries';

import { CreateProjectDispatchAction } from '../types';

interface CountrySelectorProps {
  dispatch: CreateProjectDispatchAction;
  countries: string[];
}

export function CountrySelector({ dispatch, countries }: CountrySelectorProps): JSX.Element {
  const { t } = useLang();

  const updateCountries = useCallback(
    (selectedCountries: string[]) => {
      dispatch({
        countries: selectedCountries,

        services: ({ services, currency }) =>
          services.map(({ costs, ...rest }) => ({
            ...rest,
            costs: Object.fromEntries(
              selectedCountries.map((country) => [
                country,
                costs[country] ||
                  rest.baseCosts.map((cost) => ({
                    ...cost,
                    currency: cost.type === 'CURRENCY' ? currency : undefined,
                    value: '',
                  })),
              ]),
            ),
          })),

        demographics: ({ demographics }) =>
          Object.fromEntries(
            Object.entries(demographics).filter(([country]) => selectedCountries.includes(country)),
          ),
      });
    },
    [dispatch],
  );

  return (
    <LabeledSelect
      label={t('field-countries') || ''}
      options={COUNTRIES}
      value={countries}
      onChangeDirect={updateCountries}
      labelIcon={EarthIcon}
      isMulti
    />
  );
}
